import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { SearchResultsSection } from '../SearchResultsSection/SearchResultsSection'

import { OpportunityCardSkeleton } from '@percent/workplace-giving/common/components/OpportunityCard/OpportunityCardSkeleton'
import { OpportunityCard } from '@percent/workplace-giving/common/components/OpportunityCard/OpportunityCard'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import { formatNumberToLocale } from '@percent/workplace-giving/utils/formatNumberToLocale/formatNumberToLocale'
import { ListResponse } from '@percent/workplace-giving/api/goodstack'
import { SearchOpportunitiesResponseRow } from '@percent/workplace-giving/api/search/searchOpportunities/searchOpportunities.types'

type VolunteeringResultsProps = Readonly<{
  data?: ListResponse<SearchOpportunitiesResponseRow>
  isFetching: boolean
  query?: string
  countryCode: string
}>

export function VolunteeringResults({ data, isFetching, query, countryCode }: VolunteeringResultsProps) {
  const {
    t,
    i18n: { language }
  } = useTranslation()
  const items = useMemo(
    () =>
      data?.data?.map(opportunity => ({
        id: opportunity.id,
        content: <OpportunityCard key={opportunity.id} opportunity={opportunity} />
      })) ?? [],
    [data]
  )

  return (
    <SearchResultsSection
      title={t('workplace_giving.globalSearch.searchResults.volunteering', {
        totalResults: formatNumberToLocale(language, data?.totalResults || 0)
      })}
      noResultsText={t('workplace_giving.globalSearch.searchResults.noVolunteering')}
      totalResults={data?.totalResults || 0}
      isFetching={isFetching}
      items={items}
      skeleton={<OpportunityCardSkeleton />}
      seeAllTo={`${AppRoute.VOLUNTEERING}?query=${query}&country=${countryCode}`}
      seeAllNavigateOptions={{ state: { scrollToOpportunitiesList: true } }}
    />
  )
}
